export default "__VITE_ASSET__B7zXWr3a__"